import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const NoItemsTr = styled.tr`
  td {
    vertical-align: middle;
    padding: 10px 0;
    border: none;
    border-bottom: 1px solid #f0f2f6;
  }
  &:hover {
    td {
      background: none !important;

      img {
        transform: none !important;
      }
    }
  }

  &:nth-child(1) {
    td {
      border: none !important;
    }
  }
  &:nth-child(3) {
    opacity: 0.7;
    animation-delay: 0.2s;
  }
  &:nth-child(4) {
    opacity: 0.6;
    animation-delay: 0.4s;
  }
  &:nth-child(5) {
    opacity: 0.5;
    animation-delay: 0.6s;
  }
  &:nth-child(6) {
    opacity: 0.4;
    animation-delay: 0.8s;
  }

  &:nth-child(3) {
    td {
      animation-delay: 0.2s;
    }
  }
  &:nth-child(4) {
    td {
      animation-delay: 0.4s;
    }
  }
  &:nth-child(5) {
    td {
      animation-delay: 0.6s;
    }
  }
  &:nth-child(6) {
    td {
      animation-delay: 0.8s;
    }
  }

  td {
    animation-name: ${props => (props.isLoading ? 'loading' : '')};
    animation-duration: 1.5s;
    animation-iteration-count: infinite;
  }

  @keyframes loading {
    50% {
      opacity: 0.4;
    }
  }
`;
const FlexWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const PlaceholderItem = styled.div`
  background: #f0f2f6;
  width: 88px;
  height: 23px;
`;

const ScaledPlaceholderItem = styled(PlaceholderItem)`
  width: 80%;
  height: 80%;
`;

const ImagePlaceholder = styled(PlaceholderItem)`
  height: 56px;
`;

const AvatarPlaceholder = styled(PlaceholderItem)`
  width: 56px;
  height: 56px;
  border-radius: 100%;
`;

const FilePlaceholder = styled(PlaceholderItem)`
  width: 24px;
  height: 24px;
`;

const TitlePlaceholder = styled(PlaceholderItem)`
  width: 218px;
`;

const UserNamePlaceholder = styled(PlaceholderItem)`
  width: 102px;
`;

const SubTitlePlaceholder = styled(PlaceholderItem)`
  width: 287px;
  height: 14px;
  margin-top: 10px;
`;

const DatePlaceholder = styled(PlaceholderItem)`
  width: 91px;
  height: 16px;
`;

const SubDatePlaceholder = styled(PlaceholderItem)`
  width: 108px;
  height: 16px;
  margin-top: 10px;
`;

const UserPlaceholder = styled(PlaceholderItem)`
  width: 48px;
  height: 48px;
  border-radius: 100%;
`;

const LabelPlaceholder = styled(PlaceholderItem)`
  width: 88px;
  height: 23px;
`;

const OptionsPlaceholder = styled(PlaceholderItem)`
  float: right;
  width: 30px;
  height: 30px;
`;

const EventPlaceholderWrapper = ({ isLoading }) => (
  <NoItemsTr isLoading={isLoading}>
    <td>
      <ImagePlaceholder />
    </td>
    <td>
      <TitlePlaceholder />
      <SubTitlePlaceholder />
    </td>
    <td>
      <LabelPlaceholder />
    </td>
    <td>
      <UserPlaceholder />
    </td>
    <td>
      <OptionsPlaceholder />
    </td>
  </NoItemsTr>
);

const UpcomingEventPlaceholderWrapper = ({ isLoading }) => (
  <NoItemsTr isLoading={isLoading}>
    <td>
      <ImagePlaceholder />
    </td>
    <td>
      <TitlePlaceholder />
      <SubTitlePlaceholder />
    </td>
    <td>
      <LabelPlaceholder />
    </td>
    <td>
      <UserPlaceholder />
    </td>
    <td></td>
  </NoItemsTr>
);

const FilesPlaceholderWrapper = ({ isLoading }) => (
  <NoItemsTr isLoading={isLoading} data-testid="files-placeholder">
    <td>
      <FilePlaceholder />
    </td>
    <td>
      <TitlePlaceholder />
      <SubTitlePlaceholder />
    </td>
    <td>
      <DatePlaceholder />
      <SubDatePlaceholder />
    </td>
    <td>
      <DatePlaceholder />
      <SubDatePlaceholder />
    </td>
    <td>
      <OptionsPlaceholder />
    </td>
  </NoItemsTr>
);

const UserlPlaceholderWrapper = ({ isLoading, isCrew }) => (
  <NoItemsTr isLoading={isLoading}>
    <td>
      <FlexWrapper>
        <AvatarPlaceholder />
        <UserNamePlaceholder style={{ marginLeft: '50px' }} />
      </FlexWrapper>
    </td>
    <td>
      <TitlePlaceholder />
    </td>
    {isCrew && (
      <td>
        <UserNamePlaceholder />
      </td>
    )}
    <td>
      <OptionsPlaceholder />
    </td>
  </NoItemsTr>
);

const GridPlaceholder = ({ type, isLoading }) => {
  const items = [1, 2, 3, 4, 5];

  return items.map(item => {
    const key = `placeholder-${type}-${item}`;
    const commonProps = { key, isLoading };

    if (type === ContentType.Event)
      return <EventPlaceholderWrapper {...commonProps} />;
    if (type === ContentType.UpcomingEvent)
      return <UpcomingEventPlaceholderWrapper {...commonProps} />;
    if (type === ContentType.Files)
      return <FilesPlaceholderWrapper {...commonProps} />;
    if (type === ContentType.User)
      return <UserlPlaceholderWrapper {...commonProps} />;
    if (type === ContentType.Crew)
      return <UserlPlaceholderWrapper {...commonProps} isCrew />;
    return null;
  });
};

const ContentType = {
  Event: 'event',
  UpcomingEvent: 'upcoming_event',
  Files: 'files',
  User: 'user',
  Crew: 'crew'
};

GridPlaceholder.defaultProps = {
  isLoading: false,
  type: ContentType.Event
};

GridPlaceholder.propTypes = {
  isLoading: PropTypes.bool,
  type: PropTypes.oneOf(['event', 'files', 'user', 'crew'])
};

export { ContentType, NoItemsTr, ScaledPlaceholderItem };
export default GridPlaceholder;
